/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CatalogProductBulkImportBodyParams } from '../models/CatalogProductBulkImportBodyParams';
import type { CatalogProductBulkImportResponse } from '../models/CatalogProductBulkImportResponse';
import type { CatalogProductCreateBodyParams } from '../models/CatalogProductCreateBodyParams';
import type { CatalogProductCreateResponse } from '../models/CatalogProductCreateResponse';
import type { CatalogProductDeleteResponse } from '../models/CatalogProductDeleteResponse';
import type { CatalogProductGetResponse } from '../models/CatalogProductGetResponse';
import type { CatalogProductListResponse } from '../models/CatalogProductListResponse';
import type { CatalogProductSearchResponse } from '../models/CatalogProductSearchResponse';
import type { CatalogProductUpdateBodyParams } from '../models/CatalogProductUpdateBodyParams';
import type { CatalogProductUpdateResponse } from '../models/CatalogProductUpdateResponse';
import type { SearcherDocumentSearchBodyParams } from '../models/SearcherDocumentSearchBodyParams';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CatalogProductsService {
    /**
     * @param id
     * @returns CatalogProductGetResponse Ok
     * @throws ApiError
     */
    public static getProduct(
        id: number,
    ): CancelablePromise<CatalogProductGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/catalog/products/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns CatalogProductUpdateResponse Ok
     * @throws ApiError
     */
    public static updateProduct(
        id: number,
        requestBody: CatalogProductUpdateBodyParams,
    ): CancelablePromise<CatalogProductUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/catalog/products/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param id
     * @returns CatalogProductDeleteResponse Ok
     * @throws ApiError
     */
    public static deleteProduct(
        id: number,
    ): CancelablePromise<CatalogProductDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/catalog/products/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @param tenantId
     * @returns CatalogProductListResponse Ok
     * @throws ApiError
     */
    public static listProducts(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
        tenantId?: string,
    ): CancelablePromise<CatalogProductListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/catalog/products',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
                'tenantId': tenantId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogProductCreateResponse Ok
     * @throws ApiError
     */
    public static createProduct(
        requestBody: CatalogProductCreateBodyParams,
    ): CancelablePromise<CatalogProductCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/products',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogProductSearchResponse Ok
     * @throws ApiError
     */
    public static searchProducts(
        requestBody: SearcherDocumentSearchBodyParams,
    ): CancelablePromise<CatalogProductSearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/products/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogProductBulkImportResponse Ok
     * @throws ApiError
     */
    public static importProducts(
        requestBody: CatalogProductBulkImportBodyParams,
    ): CancelablePromise<CatalogProductBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/products/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
